// extracted by mini-css-extract-plugin
export default {"container":"ReviewsSection_container__1jRS3","reviewsContainer":"ReviewsSection_reviewsContainer__R4HNS"};